import React, { useState } from 'react';
import './Testimonial.css';

const testimonials = [
    {
        id: 1,
        text: '"Prime Rehab equipment is reliable and well-designed. It has improved the efficiency of treatments in our physiotherapy clinic."',
        name: 'Dr. Arun Kumar',
        title: '- Physiotherapist'
    },
    {
        id: 2,
        text: '"The spinal decompression tables are top-notch. Our patients report feeling safe, and the build quality ensures it can handle high clinic volume without fail."',
        name: 'Dr. Sarah Jenkins',
        title: '- Lead Chiropractor'
    },
    {
        id: 3,
        text: '"Fantastic customer support and incredible rehab systems. The motorized high-low tables have made patient transfers incredibly smooth for our staff."',
        name: 'James O\'conner',
        title: '- Clinic Director'
    }
];

const Testimonial = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <section className="testimonial-section">
            <div className="testimonial-container">
                <span className="section-subtitle">TESTIMONIAL</span>
                <h2 className="section-title">What Our Clients Say</h2>

                <div className="testimonial-content">
                    <div className="quote-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
                            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.570 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                        </svg>
                    </div>

                    <div className="testimonial-carousel">
                        <div className="testimonial-details">
                            <p className="testimonial-text">
                                {testimonials[currentIndex].text}
                            </p>
                            <div className="testimonial-author">
                                <span className="author-name">{testimonials[currentIndex].name}</span>
                                <span className="author-title">{testimonials[currentIndex].title}</span>
                            </div>
                        </div>

                        <div className="testimonial-controls">
                            <button className="test-nav-btn" onClick={handlePrev} aria-label="Previous testimonial">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </button>
                            <button className="test-nav-btn" onClick={handleNext} aria-label="Next testimonial">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
